import { render, staticRenderFns } from "./UiTableOrderDurationReport.vue?vue&type=template&id=5ed19c84&scoped=true"
import script from "./UiTableOrderDurationReport.vue?vue&type=script&lang=js"
export * from "./UiTableOrderDurationReport.vue?vue&type=script&lang=js"
import style0 from "./UiTableOrderDurationReport.vue?vue&type=style&index=0&id=5ed19c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed19c84",
  null
  
)

export default component.exports